export class Entity {

}  